export default {
  computed: {
    isHomePage () {
      return this.$route && this.$route.name === 'home'
    }
  }
}
